import { PermissionSet, usePermission, usePermissionsLoaded } from './PermissionContext'

/** Matches BE file retrieve: FILES_READ, document-linked BOOKKEEPING_READ, or invoicing-scoped reads. */
export const useCanFetchAttachmentFile = (): boolean => {
  const permissionsLoaded = usePermissionsLoaded()
  const canViewFiles = usePermission(PermissionSet.FILES_VIEW)
  const canViewBookkeeping = usePermission(PermissionSet.BOOKKEEPING_VIEW)
  const canViewInvoicing = usePermission(PermissionSet.INVOICING_VIEW)

  return permissionsLoaded && (canViewFiles || canViewBookkeeping || canViewInvoicing)
}
